import React, { useState } from 'react';
import { Grid } from 'semantic-ui-react';
import AllProjects from '../components/Projects';
import SearchProjects from '../components/Projects/SearchProjects';
import CreateProjectButton from '../components/Projects/CreateProjectButton';
import ProjectSearchInput from '../components/Projects/ProjectSearchInput';

const Projects = () => {
  const [query, setQuery] = useState('');
  return (
    <Grid id="projects" stackable>
      <Grid.Row columns={2}>
        <Grid.Column width={4}>
          <ProjectSearchInput setQuery={setQuery} />
        </Grid.Column>
        <Grid.Column textAlign="right" floated="right">
          <CreateProjectButton />
        </Grid.Column>
      </Grid.Row>
      {query ? (
        <SearchProjects query={query} />
      ) : (
        <AllProjects />
      )}
    </Grid>
  );
};

export default Projects;
